import { render, staticRenderFns } from "./PaymentHistories.vue?vue&type=template&id=dff45ccc"
import script from "./PaymentHistories.vue?vue&type=script&lang=js"
export * from "./PaymentHistories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports